import { useTranslation } from 'react-i18next';

import Typography from '../../components/Typography';
import { i18nNS } from '../../i18n';
import ChevronRightIcon from '../../icons/ChevronRightIcon';
import SpeakerphoneIcon from '../../icons/SpeakerphoneIcon';
import { ListItem, ListItemButton, ListItemIcon, ListItemText } from '../styles';
import FeatureUpdatesDrawer from './FeatureUpdatesDrawer';
import useFeatureUpdatesVM from './vm';

const FeatureUpdates = () => {
  const { t } = useTranslation([i18nNS.SETTINGS]);

  const { isFeatureUpdatesDrawerOpen, handleCloseFeatureUpdatesDrawer, handleFeatureUpdates } =
    useFeatureUpdatesVM();

  return (
    <ListItem disableGutters disablePadding>
      <ListItemButton
        id="open-feature-updates-drawer"
        onClick={handleFeatureUpdates}
        aria-label={t('click_to_check_new_feature_updates', { ns: i18nNS.SETTINGS })}
        aria-haspopup="dialog"
      >
        <ListItemIcon>
          <SpeakerphoneIcon aria-hidden />
        </ListItemIcon>
        <ListItemText>
          <Typography variant="h6Regular" component="div">
            {t('feature_updates', { ns: i18nNS.SETTINGS })}
          </Typography>
        </ListItemText>
        <ChevronRightIcon aria-hidden color="disabled" />
      </ListItemButton>
      <FeatureUpdatesDrawer open={isFeatureUpdatesDrawerOpen} onClose={handleCloseFeatureUpdatesDrawer} />
    </ListItem>
  );
};

export default FeatureUpdates;
